export const INCREMENT_PRODUCT = "PRODUCT/INCREMENT_PRODUCT";
export const DECREMENT_PRODUCT = "PRODUCT/DECREMENT_PRODUCT";
export const ADD_PRODUCT = "PRODUCT/ADD_PRODUCT";